import React from 'react'
import Link from '../Link'
import * as styles from './index.module.css'
import { dynamicSort } from '../../utils'

const LowerMobileNav = ({ superNavLinks }) => {
  return (
    <div className={styles.lowerMobileNav}>
      {superNavLinks && (
        <div>
          {superNavLinks
            .sort(dynamicSort('order'))
            .map(({ label, defaultUrl, hide }, index) =>
              hide ? (
                ''
              ) : defaultUrl ? (
                <Link
                  key={index}
                  to={(defaultUrl += defaultUrl.endsWith('/') ? '' : '/')}
                >
                  <span>{label}</span>
                </Link>
              ) : (
                <span key={index}>{label}</span>
              )
            )}
        </div>
      )}

      <hr />
    </div>
  )
}
export default LowerMobileNav
